'use strict';

/* Filters */

angular.module('substoreApp.filters', [])
/** the filter 'i18n' is just a short alias for the filter 'translate' from the angular-translate project */
    .filter('i18n', ['$filter', function ($filter) {
        return $filter('translate');
    }])
    .filter('limitFrom', function() {
        return function(input, start) {
            if (input === undefined || input === null)
                return input;

            return input.slice(+start);
        };
    })
    .filter('translateIntervalUnit', function() {
        return function (input, factor) {
            if (input === undefined || input === null)
                return "";
            input = input.toString();

            if (factor === undefined || input === null)
                factor = 1;
            factor = factor.toString();

            switch (input) {
                case "0" : return "";
                case "1" : return "day"+(factor>1?"s":"");
                case "2" : return "week"+(factor>1?"s":"");
                case "3" : return "month"+(factor>1?"s":"");
                case "5" : return "hour"+(factor>1?"s":"");
                case "6" : return "minute"+(factor>1?"s":"");
                case "12" : return "year"+(factor>1?"s":"");
                default : return input;
            }
        }
    })
    .filter('translateChargingIntervalPrice', ['$filter', function($filter) {
        return function (input) {
            var unit = $filter('translateIntervalUnit')(input);
            if (!unit) return $filter('translate')('price');
            return $filter('translate')('price_label_'+unit);
        }
    }])
    .filter('translateChargingInterval', ['$filter', function($filter) {
        return function (input, factor) {
            if ( factor == 1 ) {
              return $filter('translate')('charging_interval_singular', {unit: $filter('translate')( $filter('translateIntervalUnit')(input, factor) ) } );
            } else {
              return $filter('translate')('charging_interval', {count: factor, unit: $filter('translate')( $filter('translateIntervalUnit')(input, factor) ) } );
            }
        }
    }])
    .filter('translateFromFirstUnit', ['$filter', function($filter) {
        return function (input, suffix) {
            if (!suffix) suffix = "";
            else suffix = '_' + suffix;
            return $filter('translate')('from_first_'+$filter('translateIntervalUnit')(input)+suffix);
        }
    }])
    .filter('translateFirstToXUnit', ['$filter', function($filter) {
        return function (input, factor) {
            return $filter('translate')('first_to_x_'+$filter('translateIntervalUnit')(input), {duration: factor } );
        }
    }])
    .filter('translatePerUnit', ['$filter', function($filter) {
        return function (input) {
            return $filter('translate')('per_unit', {unit: $filter('translate')( $filter('translateIntervalUnit')(input) ) } );
        }
    }])
    .filter('translateFromXUnit', ['$filter', function($filter) {
        return function (input, factor, suffix) {
            if (!suffix) suffix = "";
            else suffix = '_' + suffix;
            return $filter('translate')('from_x_'+$filter('translateIntervalUnit')(input)+suffix, {duration: factor+1 } );
        }
    }])
    .filter('translateWithAlternates', ['$filter', function($filter) {
        return function (input, alternates, additionalArgs) {
            return (alternates && alternates.hasOwnProperty(input)) && alternates[input] || $filter('translate')(input, additionalArgs);
        }
    }]);


